import type { EffectPackageItem, EffectPackageParameterSpec } from './effectPackages';

export type SilenceSetting = 'silenceSpeed' | 'silenceLevel';

const LABELS: Record<SilenceSetting, string> = {
  silenceSpeed: 'Slowdown when the music stops',
  silenceLevel: 'Dim when the music stops',
};

export interface SilenceControl {
  key: SilenceSetting;
  label: string;
  spec: EffectPackageParameterSpec & { default: number; min: number; max: number };
}

/** These fields are offered only when the bound controller publishes their numeric descriptors. */
export function silenceFallbackControls(card: EffectPackageItem | undefined): SilenceControl[] {
  return (Object.keys(LABELS) as SilenceSetting[]).flatMap((key) => {
    const spec = card?.parameters?.[key];
    if (spec?.type !== 'number' || typeof spec.default !== 'number' || !Number.isFinite(spec.default)
        || typeof spec.min !== 'number' || !Number.isFinite(spec.min)
        || typeof spec.max !== 'number' || !Number.isFinite(spec.max)) return [];
    return [{ key, label: LABELS[key], spec: spec as SilenceControl['spec'] }];
  });
}
